module.exports = __webpack_public_path__ + "static/app-7-7eb279e948b20d33aea310760e001aaf.png";